import moment from "moment";

export const emptyValue = "-";

export const ACTIVITY_LABELS = {
  locked: "Locked",
  unlocked: "Unlocked",
  access_denied: "Access Denied",
  disconnected: "Disconnected",
  connected: "Connected",
  low_battery: "Low Battery",
  battery_status_changed: "Battery Changed",
  connection_became_flaky: "Connection Flaky",
  connection_stabilized: "Connection Stable",
  tampered: "Tampered",
  name_changed: "Name Changed",
  device_added: "Device Added",
  device_removed: "Device Removed",
  device_deleted: "Device Deleted",
  connected_account_connected: "Account Connected",
  connected_account_disconnected: "Account Disconnected",
  connected_account_reauthorization_requested: "Account Reauth Needed",
  connected_account_completed_first_sync: "Account Synced",
  connected_account_completed_first_sync_after_reconnection: "Account Resynced",
  connected_account_created: "Account Created",
  connected_account_deleted: "Account Deleted",
  connected_account_successful_login: "Account Login",
};

export const getActivityType = (item = {}) =>
  item.activity_type || item.event_type || item.status || "event";

export const labelize = (value) => {
  if (!value) return emptyValue;
  return String(value)
    .replace(/\./g, "_")
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const getActivityLabel = (item = {}) => {
  const type = getActivityType(item);
  return ACTIVITY_LABELS[type] || labelize(type);
};

export const getActivityTone = (item = {}) => {
  const type = getActivityType(item);

  if (["locked", "unlocked", "connected", "connection_stabilized", "device_added", "connected_account_connected", "connected_account_completed_first_sync", "connected_account_completed_first_sync_after_reconnection", "connected_account_successful_login"].includes(type)) {
    return "success";
  }

  if (["access_denied", "low_battery", "battery_status_changed", "connection_became_flaky", "connected_account_reauthorization_requested"].includes(type)) {
    return "warning";
  }

  if (["disconnected", "tampered", "device_removed", "device_deleted", "connected_account_disconnected", "connected_account_deleted"].includes(type)) {
    return "danger";
  }

  return "neutral";
};

export const formatTimestamp = (value) => {
  if (!value) return emptyValue;
  const date = moment.utc(value);
  return date.isValid() ? date.local().format("MM/DD/YYYY hh:mm A") : emptyValue;
};

export const formatDateInput = (value, fallback) => {
  const date = value ? moment(value) : moment(fallback);
  return date.isValid() ? date.format("YYYY-MM-DD") : "";
};

export const formatBatteryLevel = (value) => {
  if (value === null || value === undefined || value === "") return emptyValue;
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return String(value);
  const percent = numeric <= 1 ? numeric * 100 : numeric;
  return `${Math.round(percent)}%`;
};

export const formatBooleanState = (value, trueLabel, falseLabel) => {
  if (value === true) return trueLabel;
  if (value === false) return falseLabel;
  return "Unknown";
};

export const getDeviceName = (device = {}) =>
  device.display_name || device.device_name || device.name || device.device_id || emptyValue;

export const getRentalName = (item = {}) =>
  item.rental_name || (item.rental_id ? `Property ${item.rental_id}` : emptyValue);
